import React from 'react';
import { connect } from 'react-redux';
import pt from 'prop-types';

import LoadingView from 'components/view/loading';

import actions from 'partners/actions';

const mapDispatchToProps = (dispatch) => ({
  acceptStoreInvite: (code) => {
    return dispatch(actions.partner.acceptStoreInvite(code));
  },

  flashSuccess: (message) => {
    dispatch(actions.flash.success(message));
  },

  flashError: (message) => {
    dispatch(actions.flash.error(message));
  },
});

let acceptingInviteCode = null;

/**
 * The last step of a store's partner invite (see `AcceptStore`), inside the
 * partner dashboard picked for it: connects the store to this partner, or
 * says why it can't be, then shows the Stores page.
 */
export class AcceptStoreConnect extends React.PureComponent {
  static propTypes = {
    params: pt.shape({ code: pt.string }).isRequired,
    router: pt.object,
    acceptStoreInvite: pt.func,
    flashSuccess: pt.func,
    flashError: pt.func,
  };

  async componentDidMount() {
    const { params, router, acceptStoreInvite, flashSuccess, flashError } =
      this.props;

    if (acceptingInviteCode === params.code) {
      return;
    }

    acceptingInviteCode = params.code;
    const result = await acceptStoreInvite(params.code);
    acceptingInviteCode = null;

    router.replace('/stores');

    if (result && !result.error) {
      flashSuccess(
        `${result.client_name} was connected to ${result.partner_name}`,
      );
    } else {
      flashError(result?.error?.message || 'An unknown error occurred');
    }
  }

  render() {
    return <LoadingView />;
  }
}

export default connect(null, mapDispatchToProps)(AcceptStoreConnect);
